// extracted by mini-css-extract-plugin
export default {"SignIn":"SupportSignIn_SignIn__wJc0r","SignIn-content-container":"SupportSignIn_SignIn-content-container__tEsoQ","SignIn-content":"SupportSignIn_SignIn-content__jE+PH"};